export const model = {
    id : null,  
    check_list_id: '', 
    text: '', 
    is_done: '', 
    end_date: '', 
    created_at: '',
    updated_at: ''  
  };
  